<template>
  <v-container fluid>
    <v-form ref="form" v-if="candidato">
      <div class="subtitle-1 font-weight-bold mb-2">
        Selecione o motivo da solicitação:
      </div>
      <v-radio-group v-model="motivoSelecionado" :rules="motivoRules">
        <v-radio
          v-for="motivo in motivos"
          :key="motivo"
          :label="motivo"
          :value="motivo"
        ></v-radio>
      </v-radio-group>

      <v-btn
        class="info mt-4"
        rounded
        depressed
        min-width="130"
        :loading="atualizando"
        @click="finalizarSolicitacao"
        >Finalizar<v-icon class="ml-2">mdi-check</v-icon>
      </v-btn>
      <v-btn text rounded small class="ml-2 mt-4" @click="setStep(2)"
        >Anterior</v-btn
      >
    </v-form>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";

export default {
  computed: mapState("candidaturainterna", [
    "candidato",
    "tipoSelecao",
    "vagaSelecionada",
  ]),
  data: () => ({
    motivoRules: [(v) => !!v || "Selecione um motivo"],
    atualizando: false,
    motivoSelecionado: null,
    motivos: [
      "Perspectiva Aumento Salarial",
      "Perspectiva de evolução Profissional",
      "Adequação de horario",
      "Mudança de função",
    ],
  }),
  methods: {
    ...mapMutations("candidaturainterna", ["setStep"]),
    // async finalizarSolicitacao() {
    //   if (!this.$refs.form.validate()) return;

    //   console.log("finalizarSolicitacao");
    //   this.atualizando = true;
    //   try {
    //     // 1) se for VAGA, registra candidatura (idVaga)
    //     if (this.tipoSelecao === "VAGA") {
    //       if (!this.vagaSelecionada?.id) {
    //         this.$toasted.error("Selecione uma vaga antes de finalizar.");
    //         this.setStep(2);
    //         return;
    //       }

    //       await axios.post(
    //         "/colaborador/candidatura-vagas?funcao=CANDIDATAR-VAGA",
    //         { idVaga: this.vagaSelecionada.id }
    //       );
    //     }

    //     console.log("finalizarSolicitacao antes do HCM ATUALIZAR");

    //     // 2) sempre salva motivo no HCM
    //     const res = await axios.post(
    //       "/colaborador/candidatura-interna?funcao=ATUALIZAR-EXPECTATIVAS",
    //       { observacao: this.motivoSelecionado }
    //     );

    //     if (res.data?.success) {
    //       this.setStep(1);
    //       this.$toasted.success("Solicitação finalizada com sucesso");
    //     } else {
    //       this.$toasted.error(res.data?.msg || "Falha ao finalizar");
    //     }
    //   } catch (e) {
    //     this.$toasted.error("Falha ao finalizar solicitação");
    //   } finally {
    //     this.atualizando = false;
    //   }
    // },

    async finalizarSolicitacao() {
      if (!this.$refs.form.validate()) return;

      this.atualizando = true;

      try {
        // Se for VAGA: antes de tudo, grava a vaga/área no HCM (igual Banco)
        if (this.tipoSelecao === "VAGA") {
          const tag = this.vagaSelecionada?.tagVaga;

          if (!tag) {
            this.$toasted.error(
              "Vaga selecionada sem Tag. Recarregue e tente novamente.",
            );
            this.setStep(1);
            return;
          }

          console.log(
            "[MotivoSolicitacao] Atualizando áreas de interesse (tag):",
            tag,
          );

          // grava no HCM o interesse (mesma rota do banco de talentos)
          // POST com query param 'funcao' e body 'areas'
          const resArea = await axios.post(
            "/colaborador/candidatura-interna",
            { areas: [tag] },
            {
              params: {
                funcao: "ATUALIZAR-AREAS-INTERESSE",
              },
            },
          );

          if (!resArea.data?.success) {
            console.error(
              "[MotivoSolicitacao] Falha gravar area:",
              resArea.data,
            );
            this.$toasted.error(
              resArea.data?.msg || "Falha ao salvar a vaga/área de interesse",
            );
            return;
          } else {
            console.log(
              "[MotivoSolicitacao] Area gravada com sucesso:",
              resArea.data,
            );
          }

          if (this.vagaSelecionada?.id) {
            console.log(
              "[MotivoSolicitacao] Registrando candidatura. ID:",
              this.vagaSelecionada.id,
            );
            // Sanitize motive to avoid encoding issues on backend (Progress 4GL MATCHES)
            // Backend checks: *evolu* OR *evolução*
            // We'll replace accented chars to ensure it matches *evolu* safely if encoding is messed up.
            const safeObservacao = this.motivoSelecionado
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");

            console.log(
              "[MotivoSolicitacao] Motivo Sanitizado:",
              safeObservacao,
            );

            // POST com query param 'funcao' e body 'idVaga' + 'observacao'
            const resCand = await axios.post(
              "/colaborador/candidatura-vagas?funcao=CANDIDATAR-VAGA",
              {
                idVaga: this.vagaSelecionada.id,
                tagVaga: this.vagaSelecionada.tagVaga, // manda também
                observacao: safeObservacao, // seu sanitizado ok
              },
            );
            console.log(
              "[MotivoSolicitacao] Resposta Candidatar:",
              resCand.data,
            );
          }
        }

        console.log(
          "[MotivoSolicitacao] Atualizando expectativa (motivo):",
          this.motivoSelecionado,
        );

        const safeObservacaoExpectativa = this.motivoSelecionado
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        // Sempre salva motivo no HCM
        // POST com query param 'funcao' e body 'observacao'
        const res = await axios.post(
          "/colaborador/candidatura-interna",
          { observacao: safeObservacaoExpectativa },
          {
            params: {
              funcao: "ATUALIZAR-EXPECTATIVAS",
            },
          },
        );
        console.log("[MotivoSolicitacao] Resposta Expectativa:", res.data);

        if (res.data?.success) {
          this.setStep(1);
          this.$toasted.success("Solicitação finalizada com sucesso");
        } else {
          this.$toasted.error(res.data?.msg || "Falha ao finalizar");
        }
      } catch (e) {
        console.error("[MotivoSolicitacao] Erro ao finalizar:", e);
        this.$toasted.error("Falha ao finalizar solicitação");
      } finally {
        this.atualizando = false;
      }
    },
  },
  mounted() {
    if (this.candidato && this.candidato.observacao) {
      // Verifica se a observação salva é um dos motivos válidos
      if (this.motivos.includes(this.candidato.observacao)) {
        this.motivoSelecionado = this.candidato.observacao;
      }
    }
  },
};
</script>
